export default "__VITE_ASSET__xJ7sJ3e8__"